<script>
import {ref} from "vue";
import IconX from "@js/components/Icons/IconX.vue";
import SpinnerIndicator from "@js/components/Statuses/SpinnerIndicator.vue";
import {use3DViewStore} from "@js/store/3dViewStore.js";

export default {
    name: "ThreeDView",
    components: {
        SpinnerIndicator,
        IconX,
    },
    setup() {
        const viewStore = use3DViewStore();
        const modalRef = ref(null);

        return {
            viewStore,
            modalRef,
        };
    },
};
</script>

<template>
    <div v-if="viewStore.show && viewStore.link"
         class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">

        <div ref="modalRef"
             class="relative w-full h-full bg-white overflow-hidden">

            <!-- Кнопка закрытия -->
            <button
                @click.prevent="viewStore.closePopup"
                :class="[viewStore.iframeLoaded ? 'md:top-3.5 md:right-14': 'top-3 right-3']"
                class="absolute top-3 right-3 z-50 pointer-events-auto text-gray-400 md:hover:text-black focus:outline-none">
                <IconX class="h-8 w-8 md:hover:stroke-black transition"
                       :class="[viewStore.iframeLoaded ? 'stroke-[#fff]': 'stroke-[#000]']"/>
            </button>

            <!-- Спиннер -->
            <div v-if="!viewStore.iframeLoaded"
                 class="absolute inset-0 flex items-center justify-center bg-white z-10">
                <SpinnerIndicator class="w-10 h-10"/>
            </div>

            <!-- iframe -->
            <iframe
                :src="viewStore.link"
                class="w-full h-full border-0 "
                sandbox="allow-scripts allow-same-origin allow-presentation"
                referrerpolicy="no-referrer"
                loading="lazy"
                @load="viewStore.iframeLoaded = true"
            ></iframe>
        </div>
    </div>
</template>

<style scoped>
/* можно добавить кастомные transition при необходимости */
</style>
